<div
  class="tab"
  [class.active]="active"
  [style.box-shadow]="boxShadow"
  (click)="tabClicked()"
>
  <span class="p3-semibold" [style.color]="color ? color : null">
    <ng-content></ng-content>
  </span>
</div>

<ng-content select="app-walk-trough"></ng-content>
